/**
 * CRM Board Skeleton
 *
 * Loading skeleton for the pipeline board
 */

import { Skeleton } from '@/components/ui/skeleton';

export function CrmBoardSkeleton() {
  return (
    <div className="flex flex-col h-full">
      {/* Header skeleton */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between mb-4">
          <div>
            <Skeleton className="h-8 w-48 mb-2" />
            <Skeleton className="h-4 w-72" />
          </div>
          <div className="flex gap-2">
            <Skeleton className="h-9 w-24" />
            <Skeleton className="h-9 w-24" />
            <Skeleton className="h-9 w-36" />
          </div>
        </div>

        {/* Metrics skeleton */}
        <div className="grid grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="bg-white border rounded-lg p-3">
              <div className="flex items-start gap-3">
                <Skeleton className="h-9 w-9 rounded-lg" />
                <div className="flex-1">
                  <Skeleton className="h-3 w-20 mb-2" />
                  <Skeleton className="h-6 w-24" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Board skeleton */}
      <div className="flex-1 overflow-x-auto p-6">
        <div className="flex gap-4">
          {[1, 2, 3, 4, 5, 6].map((col) => (
            <div key={col} className="w-72 min-w-72 flex-shrink-0">
              {/* Column header skeleton */}
              <div className="bg-gray-100 rounded-t-lg px-3 py-2 border border-b-0 border-gray-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Skeleton className="h-2 w-2 rounded-full" />
                    <Skeleton className="h-4 w-24" />
                  </div>
                  <Skeleton className="h-5 w-6 rounded-full" />
                </div>
              </div>

              {/* Column body skeleton */}
              <div className="bg-gray-50 border border-t-0 border-gray-200 rounded-b-lg p-2 min-h-[200px]">
                <div className="space-y-2">
                  {/* Deterministic card skeleton counts per column */}
                  {Array.from({ length: [2, 3, 1, 2, 1, 3][col - 1] }).map((_, idx) => (
                    <CardSkeleton key={idx} />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function CardSkeleton() {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-3 border-l-4 border-l-gray-300">
      <div className="flex items-start justify-between mb-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-6 w-6 rounded" />
      </div>
      <Skeleton className="h-3 w-1/2 mb-2" />
      <Skeleton className="h-5 w-16 rounded mb-2" />
      <Skeleton className="h-4 w-24" />
      <div className="flex items-center justify-between mt-2 pt-2 border-t border-gray-100">
        <Skeleton className="h-3 w-12" />
        <Skeleton className="h-3 w-8" />
      </div>
    </div>
  );
}
